import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RootRoute from './routes/Route';

function App() {
  return (
    <div className="App">
      <BrowserRouter>  {/* ← Only ONE router in the entire app */}
        <Routes>
          <Route path="/*" element={<RootRoute />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;